import { ROUTE } from "../../../routes";
import { CameraPickerState } from "@voltmoney/schema";
import sharedPropsService from "../../../SharedPropsService";
import { isFromMFDShareLinkJourneyPartnerSide } from "../../../configs/utils";
export const CameraAction = async (action, _datastore, { navigate, setDatastore, instrumentTrack }) => {
    instrumentTrack('CAPTURE_SELFIE_BUTTON_CLICKED');
    await setDatastore(ROUTE.CAMERA_CAPTURE, "camera", {
        state: CameraPickerState.OFF,
    });
    let base64Image = action.payload.value;
    if (base64Image && base64Image != null) {
        base64Image = base64Image.replace(/^data:image\/[a-z]+;base64,/, "");
    }
    await sharedPropsService.setPhotoSource(base64Image);
    if (isFromMFDShareLinkJourneyPartnerSide()) {
        await navigate(ROUTE.KYC_PHOTO_VERIFICATION, {
            photo: base64Image,
            isImageUploaded: true,
            showPartnerView: false
        });
    }
    else {
        await navigate(ROUTE.KYC_PHOTO_VERIFICATION, { photo: base64Image, isImageUploaded: true });
    }
};
export const CancelCameraAction = async (action, _datastore, { goBack, setDatastore, navigateWithClear }) => {
    const base64Image = await sharedPropsService.getPhotoSource();
    await setDatastore(ROUTE.CAMERA_CAPTURE, "camera", {
        isShowVideo: false,
    });
    if (base64Image) {
        await sharedPropsService.setPhotoSource(base64Image);
        navigateWithClear(ROUTE.KYC_PHOTO_VERIFICATION, { photo: base64Image, isImageUploaded: true });
    }
    else {
        goBack();
    }
};
